<template>
  <InfoPageContainer v-bind="{ id, type, value }">
    <template #header>
      <LotteryHeader />
    </template>
  </InfoPageContainer>
</template>

<script lang="ts" setup>
import { INFO_ROUTE_TYPES } from '~/constants/infoRoutes'

definePageMeta({
  key: 'lottery-info',
  layout: false,
  middleware: ['info-redirect'],
  validate: (to) =>
    !useIsMergedLotteryPage(to.params.lotteryId) &&
    useLotteriesOfLicensedTerritory().doesExist(String(to.params.lotteryId)) &&
    validateInfoRouteCreator()(to),
})

const router = useRouter()

const id = computed(() => router.currentRoute.value.params.lotteryId as string)
const type = computed(() => INFO_ROUTE_TYPES.Lottery)
const value = computed(() => String(router.currentRoute.value.params.id))
</script>
